
import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/components/ui/use-toast';

export const useSupabaseRealtime = () => {
  const { toast } = useToast();

  useEffect(() => {
    const channel = supabase.channel('supabase_metrics')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'supabase_metrics'
        },
        (payload) => {
          console.log('New metrics:', payload);
          toast({
            title: "Novas métricas disponíveis",
            description: "Os dados foram atualizados."
          });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [toast]);
};
